
<div class="container-fluid" *ngIf="!address">
    <h6 class="text-center p-4">Não há endereço cadastrado!</h6>
</div>

<div class="container-fluid" *ngIf="address">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblCep" class="custom-p-label">CEP</p>
                <p id="cep" class="custom-p-input">{{address.zipCode | maskCEP }}</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblLogradouro" class="custom-p-label">Logradouro</p>
                <p id="logradouro" class="custom-p-input">{{address.addressName}}</p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblNumero" class="custom-p-label">Número</p>
                <p id="numero" class="custom-p-input">{{address.number}}</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblComplemento" class="custom-p-label">Complemento</p>
                <p id="complemento" class="custom-p-input">{{address.complement}}</p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblBairro" class="custom-p-label">Bairro</p>
                <p id="bairro" class="custom-p-input">{{address.neighborhood}}</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblCidade" class="custom-p-label">Cidade</p>
                <p id="cidade" class="custom-p-input">{{address.city}}</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblEstado" class="custom-p-label">Estado</p>
                <p id="estado" class="custom-p-input">{{address.uf}}</p>
            </div>
        </div>
    </div>
</div>
